import printSplJob from '@afosto/utils-react/spooler/printSplJob';
import splHelpers from '@afosto/utils-react/spooler/splHelpers';
import findObjectInArray from '@afosto/utils/array/findObjectInArray';
import { search as searchApi } from '@afosto/fulfilment/api/Search';

const MAX_BARCODES = 1;

const printShipmentLabels = async (intl, shipments, options = {}) => {
  try {
    const shipmentIds = (shipments ?? []).map(shipment => shipment.shipment_id);
    const shipmentsResponse = await searchApi.searchShipments({
      constraints: [
        {
          key: 'ids',
          operator: 'in',
          value: shipmentIds,
        },
      ],
    });
    const { data: shipmentsData = [] } = shipmentsResponse;

    if (!shipmentsData?.length) {
      return false;
    }

    const barcodeLines = shipmentsData.reduce((acc, shipment, idx) => {
      const sortingData = findObjectInArray(shipments, 'shipment_id', shipment?.id);
      const { label } = sortingData;

      return [
        ...acc,
        ...[
          splHelpers.feed(),
          splHelpers.text(shipment?.number ?? '-', { align: 'center', size: 30 }),
          ...(label ? [splHelpers.text(label ?? '-', { align: 'center', size: 30 })] : []),
          splHelpers.barcode(shipment?.number, { align: 'center', height: 100 }),
          ...((idx + 1) % MAX_BARCODES === 0 ? [splHelpers.cut()] : []),
        ],
      ];
    }, []);

    return printSplJob(
      [...barcodeLines, splHelpers.cut()],
      `Print barcode for shipments: ${shipmentIds.join(', ')}`,
      options,
    );
  } catch (err) {
    return Promise.reject(err);
  }
};

export default printShipmentLabels;
